export const isPayPalWithdrawalEnabled: boolean =
  (import.meta.env.VITE_ENABLE_PAYPAL_WITHDRAWAL ?? '').toUpperCase() === 'TRUE';
